import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import VueCookies from "vue-cookies";

Vue.use(Vuex);
Vue.use(VueCookies);

export default new Vuex.Store({
  state: {
    status: "",
    token: "",
  },

  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
    },
    auth_error(state) {
      state.status = "error";
      state.token = "";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    },
  },

  actions: {
    async LoginUser({ commit }, user) {
      commit("auth_request");
      try {
        const response = await axios.post(`${enurl.apiUrl}Login/Login`, user);
        if (response.data.status === 0) {
          const { token, tenantID, username } = response.data.data;

          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
          Vue.$cookies.set("Token", token, expires);
          Vue.$cookies.set("TenantID", tenantID, expires);
          Vue.$cookies.set("Username", username, expires);
          Vue.$cookies.set("isLoggedIn", true, expires);

          localStorage.setItem("Token", token);
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("TenantID", tenantID);

          commit("auth_success", token);
          return response;
        } else {
          commit("auth_error");
          throw response;
        }
      } catch (err) {
        commit("auth_error");
        throw err;
      }
    },

    async CheckToken({ commit, dispatch }, { token }) {
      commit("auth_request");
      try {
        const response = await axios.post(`${enurl.apiUrl}Login/CheckToken`, {
          token,
        });

        if (response.data.status === 0) {
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;
          commit("auth_success", token);
          return response;
        } else if (response.data.status === 2) {
          commit("auth_success", token);
          return response;
        } else {
          await dispatch(
            "ForceLogout",
            response.data.message || "Session Expired"
          );
          throw response;
        }
      } catch (err) {
        commit("auth_error");
        throw err;
      }
    },

    async ForceLogout({ commit }, message) {
      if (this._isLoggingOut) return;
      this._isLoggingOut = true;

      commit("logout");
      localStorage.removeItem("Token");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("TenantID");

      Vue.$cookies.remove("Token");
      Vue.$cookies.remove("TenantID");
      Vue.$cookies.remove("Username");
      Vue.$cookies.remove("isLoggedIn");

      delete axios.defaults.headers.common["Authorization"];

      await Swal.fire({
        title: "Session Expired",
        text: message || "Token ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname;
          if (currentPath !== "/Login") {
            window.location.href = "/Login";
          }
        }
        this._isLoggingOut = false;
      });
    },

    async Logout({ commit }) {
      commit("logout");

      localStorage.removeItem("Token");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("TenantID");

      Vue.$cookies.remove("Token");
      Vue.$cookies.remove("TenantID");
      Vue.$cookies.remove("Username");
      Vue.$cookies.remove("isLoggedIn");

      delete axios.defaults.headers.common["Authorization"];
    },
  },
});
